<template>
  <HeaderComponent />

  <HeroComponent image="https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" text="Learn More About Us" subtitle="Meet the Swiss digital agency that believes in simple, timeless design and exceptional results." />

  <!-- About section -->
  <div class="section">
    <div class="container">
      <div class="row col-spacing-50 align-items-center">
        <div class="col-12 col-lg-6">
          <div class="box-shadow-with-hover">
            <img src="/assets/img/pexels-fauxels-3184433.jpg" alt="Diginova team working together on digital projects in modern office environment">
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <h2 class="text-3xl md:text-4xl font-bold font-heading text-gray-900 mb-6">We believe in simple and timeless design</h2>
          <div class="space-y-4">
            <p class="text-gray-600 leading-relaxed">At Diginova, we're more than just a digital agency—we're your creative partners. Based in Switzerland, we combine Swiss precision with innovative design thinking to create digital experiences that truly resonate.</p>
            <p class="text-gray-600 leading-relaxed">Our approach is rooted in listening first and designing second. We believe that great design should work for you, not the other way around. That's why we focus on creating solutions that are not only beautiful but also functional, accessible, and tailored to your unique needs.</p>
            <p class="text-gray-600 leading-relaxed">From startups to established businesses, we've helped countless clients transform their digital presence and achieve their goals through thoughtful design and strategic thinking.</p>
          </div>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
  <!-- end About section -->
  <TestimonialsComponent />
  <!-- Clients section -->
  <div class="py-20 bg-white relative overflow-hidden">
    <div class="container mx-auto px-4">
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl font-bold font-heading text-gray-900 mb-6" data-sal="slide-up" data-sal-delay="200">
          Meet Our Amazing Clients
        </h2>
        <p class="text-xl text-gray-600 max-w-2xl mx-auto" data-sal="slide-up" data-sal-delay="400">
          Trusted by innovative companies who believe in quality and excellence.
        </p>
      </div>
      
      <!-- Rotating Logos Wheel -->
      <div class="relative" data-sal="slide-up" data-sal-delay="600">
        <!-- Main wheel container -->
        <div class="wheel-container mx-auto relative">
          <div class="wheel-track">
            <!-- First set of logos -->
            <div class="wheel-logos">
              <div 
                v-for="(client, index) in [...clients, ...clients]" 
                :key="`logo-${index}`"
                class="wheel-logo"
              >
                <a 
                  :href="client.href" 
                  target="_blank" 
                  class="block p-6 hover:scale-110 transition-transform duration-300 group"
                >
                  <div class="bg-white rounded-2xl shadow-lg group-hover:shadow-xl transition-shadow duration-300 p-4 flex items-center justify-center h-20 md:h-24">
                    <img 
                      :src="client.image" 
                      :alt="`${client.alt} - Trusted client of Diginova digital agency`"
                      class="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                      loading="lazy"
                    >
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Gradient overlays for smooth edges -->
        <div class="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div class="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
      </div>
      
      <!-- Call to action -->
      <div class="text-center mt-16" data-sal="slide-up" data-sal-delay="800">
        <p class="text-gray-600 mb-6">Ready to join our family of satisfied clients?</p>
        <router-link 
          to="/contact" 
          class="inline-block bg-primary hover:bg-primary/90 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
        >
          Let's Work Together
        </router-link>
      </div>
    </div>
  </div>
  <!-- end Clients section -->
  <FooterComponent />
</template>

<script>
import HeaderComponent from '@/components/Header.vue'
import FooterComponent from '@/components/Footer.vue'
import HeroComponent from '@/components/Hero.vue'
import TestimonialsComponent from '@/components/Testimonials.vue'

export default {
  name: 'AboutView',
  components: {
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    TestimonialsComponent
  },
  data() {
    return {
      clients: [],
      isLoadingClients: true
    };
  },
  methods: {
    async loadClients() {
      try {
        this.isLoadingClients = true;
        
        // Try to load from NocoDB first
        try {
          const nocoService = (await import('@/services/nocodb.js')).default;
          const data = await nocoService.getClients();
          
          if (data && data.list && data.list.length > 0) {
            // Sort by order_index and map to expected format
            this.clients = data.list
              .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
              .map(client => ({
                href: client.url,
                image: client.logo && client.logo.length > 0
                    ? `https://web-db.drods.ch/${client.logo[0].signedPath || client.logo[0].path}`
                    : 'https://images.unsplash.com/photo-1754039985001-ccafee437736?w=150&h=150&fit=crop&crop=face&auto=format',
                alt: client.alt_text || `${client.name} logo`
              }));
          }
        } catch (nocoError) {
          // Silent Error
        }
        
        this.isLoadingClients = false;
      } catch (error) {
        this.isLoadingClients = false;
      }
    }
  },
  mounted() {
    // Load clients
    this.loadClients();
    
    "use strict";

    var htmlBody = $("html,body");
    var body = $("body");
    var windowWidth = $(window).width();


    /*===============================================
      2. Scroll Animations
    ===============================================*/
    sal({
      duration: 500
    });


    /*===============================================
      3. SmoothScroll
    ===============================================*/
    $('a[href*="#"]').not('[href="#"]').not('[data-toggle="tab"]').on("click", function(e) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          htmlBody.animate({scrollTop: target.offset().top}, 450, "easeInOutQuart");
          e.preventDefault();
        }
      }
    });



    /*===============================================
      5. Header Menu
    ===============================================*/
    //
    // Fixed //
    //
    var c, currentScrollTop = 0, header = $(".header.fixed");

    $(window).on("scroll", function () {
      var a = $(window).scrollTop();
      currentScrollTop = a;

      if (c < currentScrollTop && a > 210) {
        header.addClass("hide");
      } else if (c > currentScrollTop && !(a <= 210)) {
        header.removeClass("hide");
      }

      c = currentScrollTop;
    });

    //
    // Sticky //
    //
    if ($(".header.sticky:not(.header-lg, .header-xl, .absolute-light, .absolute-dark)").length) {
      $("<div class='header-placeholder'></div>").insertBefore(".header.sticky");
    }
    if ($(".header-lg.sticky:not(.absolute-light, .absolute-dark)").length) {
      $("<div class='header-placeholder-lg'></div>").insertBefore(".header-lg.sticky");
    }
    if ($(".header-xl.sticky:not(.absolute-light, .absolute-dark)").length) {
      $("<div class='header-placeholder-xl'></div>").insertBefore(".header-xl.sticky");
    }

    //
    // Absolute //
    //
    if ($(".absolute-light").length) {
      $(window).on("scroll", function() {
        var headerFixed = $(".header.fixed");
        if ($(window).scrollTop() > 10) {
          headerFixed.removeClass("absolute-light");
        }
        else {
          headerFixed.addClass("absolute-light");
        }
      });
    }
    if ($(".absolute-dark").length) {
      $(window).on("scroll", function() {
        var headerFixed = $(".header.fixed");
        if ($(window).scrollTop() > 10) {
          headerFixed.removeClass("absolute-dark");
        }
        else {
          headerFixed.addClass("absolute-dark");
        }
      });
    }

    //
    // Open/Close Header Menu //
    //
    var wrapper = $(".wrapper");
    var headerMenu = $(".header-menu-wrapper");
    var mToggle = $(".m-toggle");
    var closeBtn = $(".close-button");

    mToggle.on("click", function() {
      if (headerMenu.hasClass("show")) {
        headerMenu.removeClass("show");
        wrapper.removeClass("overlay");
      }
      else {
        headerMenu.addClass("show");
        wrapper.addClass("overlay");
      }
    });

    closeBtn.on("click", function() {
      if (headerMenu.hasClass("show")) {
        headerMenu.removeClass("show");
        wrapper.removeClass("overlay");
      }
    });
    $(document).on("click", function(e) {
      if ( $(e.target).closest(".header-menu-wrapper, .m-toggle").length === 0 ) {
        if (headerMenu.hasClass("show")) {
          headerMenu.removeClass("show");
          wrapper.removeClass("overlay");
        }
      }
    });

    //
    // Move Header Menu on mobile //
    //
    checkSize();
    $(window).resize(checkSize);
    function checkSize(){
      if (headerMenu.css("position") == "fixed" ) {
        headerMenu.prependTo("body");
      }
      else {
        $(".header>.container, .header>.container-fluid").append(headerMenu);
      }
    }

    //
    // Dropdown Menu //
    //
    $(".m-link").each(function() {
      var $this = $(this);
      if ($this.parent(".m-item").children(".m-dropdown").length) {
        $this.addClass("m-dropdown-toggle");
        var dropdownMenu = $this.parent(".m-item").children(".m-dropdown");

        $this.on("click", function(e) {
          if ($this.hasClass("active")) {
            $this.removeClass("active");
            dropdownMenu.removeClass("show");
          }
          else {
            $this.addClass("active");
            dropdownMenu.addClass("show");
          }
          e.preventDefault();
        });
      }
    });

    //
    // Sub Dropdown Menu //
    //
    $(".m-dropdown-link").each(function() {
      var $this = $(this);

      if ($this.parent(".m-dropdown-item").children(".m-subdropdown").length) {
        $this.addClass("m-subdropdown-toggle");
        var subDropdownMenu = $this.parent(".m-dropdown-item").children(".m-subdropdown");

        $this.on("click", function(e) {
          if ($this.hasClass("active")) {
            $this.removeClass("active");
            subDropdownMenu.removeClass("show");
          }
          else {
            $this.addClass("active");
            subDropdownMenu.addClass("show");
          }
          e.preventDefault();
        });
      }
    });


    /*===============================================
      9. Parallax Background
    ===============================================*/
    if (windowWidth > 1200) {
      var parallaxBg = $(".parallax-bg");

      if (parallaxBg.length) {
        parallaxBg.each(function() {
          $(this).parallaxie({
            speed: 0.2
          });
        });
      }
    }


    /*===============================================
      10. Background Image
    ===============================================*/
    $(".bg-image").each(function() {
      var bgData = $(this).attr("data-bg-src");
      $(this).css('background-image', 'url("' + bgData + '")');
    });


    /*===============================================
      11. Slider
    ===============================================*/
    $(".owl-carousel").each(function() {
      var $carousel = $(this);

      var $defaults = {
        rewind: true,
        navText: ["<i class='ti-angle-left'></i>","<i class='ti-angle-right'></i>"],
        autoHeight: true, 
        autoplayTimeout: 4000, 
        autoplaySpeed: 400, 
        autoplayHoverPause: true, 
        navSpeed: 350, 
        dotsSpeed: 350, 
        dragEndSpeed: 350
      }
      var $options = {
        items: $carousel.data("owl-items"),
        margin: $carousel.data("owl-margin"),
        loop: $carousel.data("owl-loop"),
        center: $carousel.data("owl-center"),
        nav: $carousel.data("owl-nav"),
        rewind: $carousel.data("owl-rewind"),
        dots: $carousel.data("owl-dots"),
        autoplay: $carousel.data("owl-autoplay")
      }
      var $responsive = {
        responsive: {
          0 : {
            items: $carousel.data("owl-xs")
          },
          576 : {
            items: $carousel.data("owl-sm")
          },
          768 : {
            items: $carousel.data("owl-md")
          },
          992 : {
            items: $carousel.data("owl-lg")
          },
          1200 : {
            items: $carousel.data("owl-xl")
          }
        }
      }

      if ($carousel.hasClass("portfolio-carousel")) {
        var $portfolioCarousel = {
          items: 2, 
          center: true
        }
      }

      if ($carousel.hasClass("product-carousel")) {
        var $productCarousel = {
          items:1,
          animateOut: 'fadeOut',
          URLhashListener:true,
          startPosition: 'URLHash'
        }
      }

      $carousel.owlCarousel( $.extend( $defaults, $options, $responsive, $portfolioCarousel, $productCarousel) );

      var customPrev = $("#customPrev");
      var customNext = $("#customNext");

      customNext.on("click", function(){
        $carousel.trigger("next.owl.carousel", [400]);
      });
      customPrev.on("click", function(){
        $carousel.trigger("prev.owl.carousel", [400]);
      });

    });


    /*===============================================
      15. Justified Gallery
    ===============================================*/
    var justifiedGallery = $(".justified-gallery");

    if (justifiedGallery.length) {
      justifiedGallery.justifiedGallery({
        rowHeight: 340, 
        margins: 10
      });
      justifiedGallery.each(function() {
        $(this).magnificPopup({
          delegate: 'a',
          removalDelay: '200',
          type: 'image',
          fixedContentPos: false,
          gallery: {
              enabled: true
          },
          image: {
            titleSrc: 'data-gallery-title'
          }
        });
      });
    }


    /*===============================================
      16. Masonry
    ===============================================*/
    var $masonryGrid = $(".masonry");
    if ($masonryGrid.length && typeof $.fn.imagesLoaded !== 'undefined' && typeof $.fn.masonry !== 'undefined') {
      $masonryGrid.imagesLoaded( function() {
        $masonryGrid.masonry({
          itemSelector: '.masonry-item', 
          columnWidth: '.masonry-item', 
          gutter: 0
        });
      });
    }


    /*===============================================
      19. Counter
    ===============================================*/
    var counter = $(".counter");

    if (counter.length) {
      counter.appear(function() {
        $(this).each(function () {
          $(this).prop("Counter",0).animate({
              Counter: $(this).text()
          }, {
              duration: 3000,
              easing: "swing",
              step: function (now) {
                  $(this).text(Math.ceil(now));
              }
          });
        });
        
      },{accX: 0, accY: -10});
    }
  }
}

</script>

<style scoped>
/* Spinning Wheel Animation */
.wheel-container {
  width: 100%;
  max-width: 1200px;
  height: 160px;
  position: relative;
  overflow: hidden;
}

.wheel-track {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.wheel-logos {
  display: flex;
  animation: spin-wheel 30s linear infinite;
  width: fit-content;
}

.wheel-logo {
  flex-shrink: 0;
  width: 200px;
  margin-right: 2rem;
}

/* Pause animation on hover */
.wheel-container:hover .wheel-logos {
  animation-play-state: paused;
}

/* Keyframes for the spinning animation */
@keyframes spin-wheel {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wheel-logo {
    width: 180px;
    margin-right: 1.5rem;
  }
  
  .wheel-container {
    height: 140px;
  }
}

@media (max-width: 480px) {
  .wheel-logo {
    width: 160px;
    margin-right: 1rem;
  }
  
  .wheel-container {
    height: 130px;
  }
}
</style>